import { defineFcm } from '../shared/factory';

export const FCM_DISABLE_ADMIN_LOGIN = defineFcm('disable_admin_login').asBoolean().withDefault(false).toConfig();
